(function () {

  if (window.__bestarooQuickAddPopupInit) return;
  window.__bestarooQuickAddPopupInit = true;


  function closePopup(wrapper) {

  var overlay = wrapper.querySelector('[data-bqa-overlay]');

  if (overlay) {

    if (typeof overlay.close === 'function' && overlay.open) {
      overlay.close();
    } else {
      overlay.removeAttribute('open');
    }

  }
}


  document.addEventListener('click', function (event) {


    /* OPEN */

    var openButton = event.target.closest('[data-bqa-open]');

    if (openButton) {

      event.preventDefault();
      event.stopPropagation();

      var wrapper = openButton.closest('[data-bqa]');
      if (!wrapper) return;

      var overlay = wrapper.querySelector('[data-bqa-overlay]');
      if (!overlay) return;
/* Load popup images only when Quick Add is opened */

wrapper.querySelectorAll('[data-bqa-image]').forEach(function (image) {

  if (!image.getAttribute('src')) {

    var imageSrc = image.getAttribute('data-bqa-src');

    if (imageSrc) {
      image.setAttribute('src', imageSrc);
    }

  }

});
      if (typeof overlay.showModal === 'function') {
  overlay.showModal();
} else {
  overlay.setAttribute('open', '');
}


      return;
    }


    /* CLOSE */

    var closeButton = event.target.closest('[data-bqa-close]');

    if (closeButton) {

      event.preventDefault();

      var closeWrapper = closeButton.closest('[data-bqa]');
      if (closeWrapper) {
        closePopup(closeWrapper);
      }

      return;
    }


    /* CLICK BACKDROP TO CLOSE */

    if (
      event.target.matches('[data-bqa-overlay]')
    ) {

      var backdropWrapper = event.target.closest('[data-bqa]');

      if (backdropWrapper) {
        closePopup(backdropWrapper);
      }

      return;
    }


    /* SELECT SIZE */

    var sizeButton = event.target.closest('[data-bqa-size]');

    if (sizeButton) {

      event.preventDefault();

      var sizeWrapper = sizeButton.closest('[data-bqa]');
      if (!sizeWrapper) return;

      sizeWrapper
        .querySelectorAll('[data-bqa-size]')
        .forEach(function (button) {
          button.classList.remove('is-selected');
        });

      sizeButton.classList.add('is-selected');

      var error = sizeWrapper.querySelector('[data-bqa-error]');

      if (error) {
        error.hidden = true;
      }

      return;
    }


    /* GALLERY PREVIOUS */

    var prevButton = event.target.closest('[data-bqa-prev]');

    if (prevButton) {

      event.preventDefault();

      var prevWrapper = prevButton.closest('[data-bqa]');
      var prevGallery =
        prevWrapper &&
        prevWrapper.querySelector('[data-bqa-gallery]');

      if (prevGallery) {
        prevGallery.scrollBy({
          left: -prevGallery.clientWidth,
          behavior: 'smooth'
        });
      }

      return;
    }


    /* GALLERY NEXT */

    var nextButton = event.target.closest('[data-bqa-next]');

    if (nextButton) {

      event.preventDefault();

      var nextWrapper = nextButton.closest('[data-bqa]');
      var nextGallery =
        nextWrapper &&
        nextWrapper.querySelector('[data-bqa-gallery]');

      if (nextGallery) {
        nextGallery.scrollBy({
          left: nextGallery.clientWidth,
          behavior: 'smooth'
        });
      }

      return;
    }


    /* ADD TO CART */

    var addButton = event.target.closest('[data-bqa-add]');

    if (!addButton) return;

    event.preventDefault();

    var addWrapper = addButton.closest('[data-bqa]');
    if (!addWrapper) return;


    var selected =
      addWrapper.querySelector('[data-bqa-size].is-selected');

    var defaultVariant =
      addWrapper.querySelector('[data-bqa-default-variant]');

    var variantId = null;


    if (selected) {
      variantId = selected.getAttribute('data-variant-id');
    } else if (defaultVariant) {
      variantId = defaultVariant.value;
    }


    if (!variantId) {

      var errorMessage =
        addWrapper.querySelector('[data-bqa-error]');

      if (errorMessage) {
        errorMessage.hidden = false;
      }

      return;
    }


    if (addButton.getAttribute('data-loading') === 'true') {
      return;
    }


    addButton.setAttribute('data-loading', 'true');

  


    var root = '/';

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      root = window.Shopify.routes.root;
    }


    /*
      Close immediately so the interaction feels instant.
      If Shopify rejects the add, we'll reopen it.
    */
    


    fetch(root + 'cart/add.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },

      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })

    })

    .then(function (response) {

      return response.json().then(function (data) {

        if (!response.ok) {
          throw data;
        }

        return data;
      });

    })

    .then(function () {

      addButton.removeAttribute('data-loading');


      /*
        Open / refresh Monster Cart.
      */

      if (typeof window.monster_refresh === 'function') {
  window.monster_refresh();
}

if (typeof window.openCart === 'function') {
  var monsterOpen = window.openCart();

  Promise.resolve(monsterOpen).finally(function () {
    closePopup(addWrapper);
  });
} else {
  closePopup(addWrapper);
}

      /*
        Reset selected size for next time.
      */

      addWrapper
        .querySelectorAll('[data-bqa-size]')
        .forEach(function (button) {
          button.classList.remove('is-selected');
        });

    })

    .catch(function (error) {

      addButton.removeAttribute('data-loading');


      /*
        Reopen popup if add failed.
      */

      var overlay = addWrapper.querySelector('[data-bqa-overlay]');

      if (overlay && !overlay.open) {
        if (typeof overlay.showModal === 'function') {
  overlay.showModal();
} else {
  overlay.setAttribute('open', '');
}
      }


      var message = 'This item could not be added. Please try again.';

      if (error && error.description) {
        message = error.description;
      }

      alert(message);

    });

  });


  /* ESC KEY */

  document.addEventListener('keydown', function (event) {

    if (event.key !== 'Escape') return;

    document
  .querySelectorAll('[data-bqa-overlay][open]')
      .forEach(function (overlay) {

        var wrapper = overlay.closest('[data-bqa]');

        if (wrapper) {
          closePopup(wrapper);
        }

      });

  });

})();
